import { render } from "./OrderContainerDetails.vue?vue&type=template&id=85187cd8&ts=true"
import script from "./OrderContainerDetails.vue?vue&type=script&lang=ts"
export * from "./OrderContainerDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__